import React from "react";
import { t } from "../../lang/index";

const SectionBenefit = () => {
  const section = t("home.sectionBenefit") as any;

  return (
    <>
      {/* Benefit Section */}
      <section className="section benefit-section bg-light-300">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center aos" data-aos="fade-up">
              <div className="section-header text-center">
                <h2 className="mb-2">
                  {section.titlePrefix}{" "}
                  <span className="text-primary text-decoration-underline">
                    {section.titleHighlight}
                  </span>{" "}
                  {section.titleSuffix}
                </h2>
                <p className="sub-title">{section.subtitle}</p>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {section.benefits.map((benefit: any, index: number) => (
              <div key={index} className="col-sm-6 col-lg-3 d-flex">
                <div
                  className="card benefit-card mb-0 flex-fill aos"
                  data-aos="fade-up"
                >
                  <div className="card-body text-center">
                    <div
                      className={`benefit-icon mb-2 text-white mx-auto ${
                        index === 0
                          ? "bg-secondary"
                          : index === 1
                          ? "bg-orange"
                          : index === 2
                          ? "bg-purple"
                          : "bg-teal"
                      }`}
                    >
                      <i
                        className={`isax ${
                          index === 0
                            ? "isax-global"
                            : index === 1
                            ? "isax-box"
                            : index === 2
                            ? "isax-car"
                            : "isax-location-tick"
                        }`}
                      />
                    </div>
                    <h5 className="mb-2">{benefit.title}</h5>
                    <p className="mb-0">{benefit.description}</p>
                    <span
                      className={`icon-view ${
                        index === 0
                          ? "text-secondary"
                          : index === 1
                          ? "text-orange"
                          : index === 2
                          ? "text-purple"
                          : "text-teal"
                      }`}
                    >
                      <i
                        className={`isax ${
                          index === 0
                            ? "isax-lock-1"
                            : index === 1
                            ? "isax-magicpen"
                            : index === 2
                            ? "isax-receipt-add"
                            : "isax-location-tick"
                        }`}
                      />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* /Benefit Section */}
    </>
  );
};

export default SectionBenefit;